import { ChangeEvent } from 'react'
import { ChatBotFooterProps } from '../../../types/chatbot'
import sendIcon from '../../../assets/send-icon.svg'
import styles from '../styles/footer.module.scss'

const ChatBotFooter = ({
  userInput,
  onInputChange,
  onEnterPress
}: ChatBotFooterProps) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    onInputChange(event.target.value)
  }

  const handleKeyDown = (event: React.KeyboardEvent<Element>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      onEnterPress()
    }
  }

  return (
    <div className={styles['chatbot-footer']}>
      <div className={styles['input-area']}>
        <input
          type='text'
          maxLength={1000}
          value={userInput}
          data-testid='chatbotInput'
          className={styles['chatbot-input']}
          placeholder='How can I help?'
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <div
          className={styles['send-button']}
          onClick={onEnterPress}
          data-testid='sendButton'
        >
          <img src={sendIcon} alt='Send' className={styles['send-icon']} />
        </div>
      </div>
      <div className={styles['footer-text']}>
        <p>Max 1000 characters</p>
        <p>Use of SensAI is subject to <a href='https://aws.amazon.com/machine-learning/responsible-ai/policy/' rel="noreferrer" target='_blank'>AWS Responsible AI Policy</a></p>
      </div>
    </div>
  )
}

export default ChatBotFooter
